import { AxiosInstance } from 'axios';

import { ActivitiesCategoryColumnsEnum } from '../../../../../admin/columns/activities-category-columns.enum';
import { axios } from '../../../../api/axios-instance';
import { activityCategoriesEndpoints } from '../../../../constants';
import { DeleteItemsInput } from '../../../../types';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import { IActivityCategory } from '../../entities/activity-category';
import {
  CategoriesResponse,
  CreateActivityCategoryInput,
} from '../../schemas/activity-category.schema';

class ActivityCategoriesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (category: CreateActivityCategoryInput): Promise<IActivityCategory> => {
    return this.#requestInstance.post(activityCategoriesEndpoints.activityCategory, category);
  };

  getCategories = async (
    data?: PaginationRequest & SortRequest<ActivitiesCategoryColumnsEnum>
  ): Promise<CategoriesResponse> => {
    return this.#requestInstance.get(activityCategoriesEndpoints.activityCategoryGet(), {
      params: data,
    });
  };

  deleteCategory = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(activityCategoriesEndpoints.getActivityCategoryById(id));
  };

  getCategoryById = async (id: number): Promise<IActivityCategory> => {
    return this.#requestInstance.get(activityCategoriesEndpoints.getActivityCategoryById(id));
  };

  updateCategory = async (input: IActivityCategory): Promise<IActivityCategory> => {
    return this.#requestInstance.patch(
      activityCategoriesEndpoints.getActivityCategoryById(input?.id),
      input
    );
  };

  deleteMany = async (ids: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(activityCategoriesEndpoints.activityCategory, {
      data: ids,
    });
  };
}

export const activityCategoriesApi = new ActivityCategoriesApi(axios);
